import { store } from "../../../store/store";
import { prepareCartData } from "./OMSCartUtils";
import { isObjectNotEmpty } from "../CommonUtils";
import { AppVersionCode, MedicineDataVersion } from "../../constants/AppConstants";

export function buildOrderRequestData({
    selectedLocation, selectedStore,
    cartItems, cartImagesList,
    additionalInstruction, userDetails }) {
    let pharmacyData = [{
        id: selectedStore['id'],
        distance: selectedStore['distance'],
        loc: selectedStore['streetAddress'],
        name: selectedStore['pharmacyName'],
        phoneNumber: selectedStore['phoneNumber'],
        prpicVersion: selectedStore['prpicVersion'],
    }]
    let orderData = {
        pwa: true,
        'ln': 'en',
        rxSource: 4,
        quickRepeat: false,
        pharmacies: pharmacyData,
        appVersionCode: AppVersionCode,
        note: additionalInstruction ?? '',
        deliveryAddress: selectedLocation['aid'],
        medicineDataVersion: MedicineDataVersion,
    }

    let cartData = prepareCartData(cartItems, cartImagesList, additionalInstruction)
    orderData = { ...orderData, ...cartData }

    if (isObjectNotEmpty(userDetails)) {
        orderData['uid'] = userDetails?.id ?? 0
        orderData['userId'] = userDetails?.id ?? 0
        orderData['familyId'] = userDetails?.familyId ?? 0
    }

    const reduxState: any = store.getState();
    if (reduxState.repeatOrderData['isRepeatOrder'])
        orderData = buildRepeatOrderRequestData(orderData)
    return orderData
}

function buildRepeatOrderPrescriptionData(orderData, repeatOrderData) {
    let imageList = orderData.imageList
    let imagesToken = []
    let base64Images = []
    imageList.forEach((image) => {
        if (image['token']) imagesToken.push(image['token'])
        else base64Images.push(image)
    })
    orderData.imageList = base64Images
    if (imagesToken.length) orderData.prescription = {
        ...repeatOrderData['prescription'], orgImages: imagesToken
    }
    return orderData
}

export function buildRepeatOrderRequestData(orderData) {
    const reduxState: any = store.getState();
    let repeatOrderData = reduxState.repeatOrderData
    orderData = {
        ...orderData,
        ooid: repeatOrderData['ooid'],
        poid: repeatOrderData['poid'],
    }
    if (orderData.imageList.length)
        orderData = buildRepeatOrderPrescriptionData(orderData, repeatOrderData)
    return orderData
}